import script from "./AvatarRubView.vue?vue&type=script&setup=true&lang=js"
export * from "./AvatarRubView.vue?vue&type=script&setup=true&lang=js"

import "./AvatarRubView.vue?vue&type=style&index=0&id=75f70f1e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-75f70f1e"]])

export default __exports__